import { FormSubmissionAnswer } from '../../../contracts/form-submission-answer.js';
import { MapUtils } from '../../../utility/map-utils.js';
import { DataModelBuilder, SerializationContext, SerializedData } from '../../dto/data-model.js';

export class BooleanFormSubmissionAnswer extends FormSubmissionAnswer {
  static readonly TYPE_ID: string = 'd0b6c4e5f7a9b1c3d4e6f8a0b2c5d7e9';

  constructor(
    public readonly questionId: string,
    public readonly value: boolean,
  ) {
    super();
  }

  get $typeId(): string {
    return BooleanFormSubmissionAnswer.TYPE_ID;
  }

  static create(args: {
    questionId: string,
    value: boolean,
  }): BooleanFormSubmissionAnswer {
    return new BooleanFormSubmissionAnswer(args.questionId, args.value);
  }

  static fromMap(context: SerializationContext, map: SerializedData): BooleanFormSubmissionAnswer {
    return new BooleanFormSubmissionAnswer(
        MapUtils.getString(map, 'questionId'),
        MapUtils.getBoolean(map, 'value'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'questionId': this.questionId,
      'value': this.value,
    };
  }

  clone(): this {
    return new BooleanFormSubmissionAnswer(this.questionId, this.value) as this;
  }

  isSame(other: BooleanFormSubmissionAnswer): boolean {
    if(other === this) {
      return true;
    }

    return other.questionId === this.questionId &&
      other.value === this.value;
  }
}

export class BooleanFormSubmissionAnswerBuilder extends DataModelBuilder<BooleanFormSubmissionAnswer> {
  build(context: SerializationContext, map: SerializedData): BooleanFormSubmissionAnswer {
    return BooleanFormSubmissionAnswer.fromMap(context, map);
  }
}
